import { useMergeRefs } from '@libs/react/ref';
import styles from './Input__DEPRECATED.module.scss';
import {
  ChangeEvent,
  CSSProperties,
  forwardRef,
  type ReactNode,
  Ref,
  useId,
  useRef,
} from 'react';
import { InputShared } from './InputShared';
import clsx from 'clsx';

interface Props {
  addonEnd?: ReactNode;
  addonStart?: ReactNode;
  align?: 'start' | 'center' | 'end';
  defaultValue?: string;
  id?: string;
  fieldSizing?: 'content';
  label?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  max?: number;
  min?: number;
  prefix?: string;
  sufix?: string;
  required?: boolean;
  type?: 'text' | 'number';
  name?: string;
  style?: CSSProperties;
}

function Implemenation(
  {
    addonEnd,
    addonStart,
    align = 'start',
    defaultValue,
    fieldSizing,
    label,
    max,
    min,
    onChange,
    prefix,
    sufix,
    type = 'text',
    style,
    required,
    id: idProps,
    ...props
  }: Props,
  ref: Ref<HTMLInputElement>,
) {
  const id = useId();
  const internalRef = useRef<HTMLInputElement>(null);
  const inputRef = useMergeRefs(internalRef, ref);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (type === 'number' && event.target.value !== '') {
      const value = Number(event.target.value);

      if (!Number.isNaN(value)) {
        if (max !== undefined && value > max) {
          event.target.value = String(max);
        } else if (min !== undefined && value < min) {
          event.target.value = String(min);
        }
      }
    }

    onChange?.(event);
  };

  const fieldClassName = [
    styles['input-element'],
    styles['align-' + align],
    styles['field-sizing-' + fieldSizing],
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <InputShared
      classNames={{
        children: clsx(styles['children'], styles['align-' + align]),
      }}
      end={addonEnd}
      label={label}
      onClick={() => internalRef.current?.focus()}
      start={addonStart}
    >
      {prefix && <span>{prefix}</span>}
      <input
        ref={inputRef}
        className={fieldClassName}
        defaultValue={defaultValue}
        id={idProps ?? id}
        max={max}
        min={min}
        onChange={handleChange}
        required={required}
        type={type}
        {...props}
      />
      {sufix && <div>{sufix}</div>}
    </InputShared>
  );
}

export const Input__DEPRECATED = forwardRef<HTMLInputElement, Props>(
  Implemenation,
);
